/* 是否手机号码*/
function validatePhone(val) {
  return /^1([38][0-9]|4[014-9]|[59][0-35-9]|6[2567]|7[0-8])\d{8}$/.test(val)
}

/**
 * 1.密码长度不小于6个字符。
 * 2.密码必须以字母开头，且不小于6个字符，不能包含特殊字符。
 * @param {*} value
 * @returns
 */
function validPasswordReg(val) {
  return /^[a-zA-Z]\w{5,17}$/g.test(val)
}

// /**
//  * 1.口令长度不小于8个字符。
//  * 2.口令应该为以下四类字符的组合，大写字母(A-Z)、小写字母(a-z)、数字(0-9)和特殊字符。每类字符至少包含一个。
//  * @param {*} value
//  * @returns
//  */
//  export function validPasswordReg(value) {
//   const reg = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{8,10}/

//   return reg.test(value)
// }

/**
 * 有效身份证号
 * @param {*} val
 * @returns
 */
function isValidIdcard(val){
  return /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(val)
}

export {
  validatePhone,
  validPasswordReg,
  isValidIdcard
}
